(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-portfolio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const lockVideoDownloads = (root = document) => {
      const videos = root.querySelectorAll('.bp-video-card__video:not([data-bp-download-locked])');

      videos.forEach((video) => {
        video.setAttribute('controlslist', 'nodownload');

        if (video.controlsList && typeof video.controlsList.add === 'function') {
          video.controlsList.add('nodownload');
        }

        video.addEventListener('contextmenu', (event) => {
          event.preventDefault();
        });
        video.setAttribute('data-bp-download-locked', 'true');
      });
    };

    const reveal = (root = document) => {
      const items = root.querySelectorAll('.bp [data-bp-reveal]:not([data-bp-reveal-bound])');

      if (!items.length) {
        return;
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => {
          item.classList.add('is-visible');
          item.setAttribute('data-bp-reveal-bound', 'true');
        });
        return;
      }

      const observer = new IntersectionObserver(
        (entries, activeObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            activeObserver.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.12
        }
      );

      items.forEach((item) => {
        item.setAttribute('data-bp-reveal-bound', 'true');
        observer.observe(item);
      });
    };

    const initFeedbackCarousels = (root = document) => {
      const carousels = root.querySelectorAll('.bp [data-bp-feedback-carousel]:not([data-bp-feedback-bound])');

      carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-bp-feedback-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-bp-feedback-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-bp-feedback-dot]'));
        const previousButton = carousel.querySelector('[data-bp-feedback-prev]');
        const nextButton = carousel.querySelector('[data-bp-feedback-next]');

        carousel.setAttribute('data-bp-feedback-bound', 'true');

        if (!track || slides.length < 2) {
          return;
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = 0;
        let autoplayTimer = null;
        let scrollFrame = null;
        let isVisible = true;

        const updateControls = () => {
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);

            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const goTo = (index, smooth = true) => {
          activeIndex = (index + slides.length) % slides.length;
          track.scrollTo({
            left: slides[activeIndex].offsetLeft,
            behavior: smooth && !reducedMotion ? 'smooth' : 'auto'
          });
          updateControls();
        };

        const stopAutoplay = () => {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        const startAutoplay = () => {
          stopAutoplay();

          if (reducedMotion || document.hidden || !isVisible) {
            return;
          }

          autoplayTimer = window.setInterval(() => {
            goTo(activeIndex + 1);
          }, 6200);
        };

        const restartAutoplay = () => {
          stopAutoplay();
          startAutoplay();
        };

        previousButton?.addEventListener('click', () => {
          goTo(activeIndex - 1);
          restartAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          goTo(activeIndex + 1);
          restartAutoplay();
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            goTo(Number(dot.dataset.bpFeedbackIndex || 0));
            restartAutoplay();
          });
        });

        track.addEventListener('scroll', () => {
          if (scrollFrame) {
            window.cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = window.requestAnimationFrame(() => {
            let closestIndex = 0;
            let closestDistance = Number.POSITIVE_INFINITY;

            slides.forEach((slide, index) => {
              const distance = Math.abs(slide.offsetLeft - track.scrollLeft);

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            if (closestIndex !== activeIndex) {
              activeIndex = closestIndex;
              updateControls();
            }
          });
        }, { passive: true });

        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', (event) => {
          if (!carousel.contains(event.relatedTarget)) {
            startAutoplay();
          }
        });
        track.addEventListener('pointerdown', stopAutoplay, { passive: true });
        track.addEventListener('pointerup', startAutoplay, { passive: true });

        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        if ('IntersectionObserver' in window) {
          const visibilityObserver = new IntersectionObserver(
            (entries) => {
              isVisible = entries.some((entry) => entry.isIntersecting);

              if (isVisible) {
                startAutoplay();
              } else {
                stopAutoplay();
              }
            },
            { threshold: 0.2 }
          );

          visibilityObserver.observe(carousel);
        }

        updateControls();
        startAutoplay();
        carousel._bpFeedbackStop = stopAutoplay;
      });
    };

    const init = (root = document) => {
      reveal(root);
      lockVideoDownloads(root);
      initFeedbackCarousels(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-bp-feedback-carousel]').forEach((carousel) => {
        carousel._bpFeedbackStop?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
